import { LazyModule } from 'owa-bundling';
import { EditorPluginEx } from 'owa-editor';
import createLazyPlugin, { LazyPlugin } from 'owa-editor-lazy-plugin/lib/utils/createLazyPlugin';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "AugLoopPlugin" */ './plugin/AugLoopPlugin')
);

export type LazyAugLoopPlugin = LazyPlugin<EditorPluginEx>;

export let LazyAugLoopPluginClass = createLazyPlugin(lazyModule, m => m.default, 'AugLoop', null);
export {
    default as AnnotationHandler,
    GetAnnotationHandlerAsync,
} from './store/schema/AnnotationHandler';
